import React from 'react'
import { Wrapper } from './styles'
import { PinLogo } from '@icons'
import './index.css'

const Spinner = ({ width = 100, height = 100 }) => {
  return (
    <Wrapper>
      <PinLogo width={width} height={height} className="animated-logo" />
    </Wrapper>
  )
}

export default Spinner
